<template>
  <c-flex :flex-direction="{ base: 'column', lg: 'row' }" :align-items="{ '2xl': 'center' }">
    <wizard-tab
      path="/shopping_cart"
      :step="1"
      :current-step="currentStep"
      data-cy="shopping-cart-link"
    >
      1. {{ $t("shoppingCart.title") }}
    </wizard-tab>

    <wizard-tab
      v-if="isUserPermittedToOrderServiceProducts"
      path="/shopping_cart"
      :step="2"
      :current-step="currentStep"
      :disabled="cartHasNoProducts"
    >
      <c-box as="span" data-cy="service-products-link">
        2. {{ $t("ordering.serviceProducts.title") }}
      </c-box>
    </wizard-tab>

    <wizard-tab
      path="/shopping_cart"
      :step="3"
      :current-step="currentStep"
      :disabled="cartHasNoProducts"
      data-cy="delivery-link"
    >
      {{ isUserPermittedToOrderServiceProducts ? "3." : "2." }}
      {{ $t("ordering.delivery.title") }}
    </wizard-tab>

    <wizard-tab
      v-if="!isError"
      path="/shopping_cart"
      :step="4"
      :current-step="currentStep"
      :disabled="cartHasNoProducts"
    >
      {{ isUserPermittedToOrderServiceProducts ? "4." : "3." }}
      {{ $t("ordering.overview.title") }}
    </wizard-tab>
    <c-box
      v-else
      fontSize="lg"
      pl="3xl"
      pr="3xl"
      pt="sm"
      pb="sm"
      borderRadius="full"
      background="transparent"
      color="gray.500"
    >
      {{ isUserPermittedToOrderServiceProducts ? "4." : "3." }}
      {{ $t("ordering.overview.title") }}
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import WizardTab from "@/components/WizardTab.vue";
import { CBox, CFlex } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "OrderTabContainer",
  components: {
    CBox,
    CFlex,
    WizardTab,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    cartHasNoProducts: {
      type: Boolean,
      required: true,
    },
    isUserPermittedToOrderServiceProducts: {
      type: Boolean,
      required: true,
    },
    isError: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
